import { Injectable, inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig, MatSnackBarRef, TextOnlySnackBar } from '@angular/material/snack-bar';
import { SnackbarOptions } from '@nx-customer-apps/shared/interfaces';
import { LodashService } from './lodash.service';

/* istanbul ignore next */
@Injectable({ providedIn: 'root' })
export class SnackbarService {
    private snackbar = inject(MatSnackBar);

    public showInfo(message: string, options?: SnackbarOptions): MatSnackBarRef<TextOnlySnackBar> {
        const config = this.getConfig(options);
        return this.snackbar.open(message, options?.action, config);
    }

    public showCustomInfo(component: any, options?: MatSnackBarConfig): MatSnackBarRef<unknown> {
        const config = this.getConfig(options);
        return this.snackbar.openFromComponent(component, config);
    }

    private getConfig(options?: Partial<MatSnackBarConfig>): MatSnackBarConfig {
        return {
            ...options,
            panelClass: options?.panelClass || ['ca-snackbar', 'ca-info'],
            duration: LodashService.isNil(options?.duration) ? 5000 : options?.duration,
            verticalPosition: options?.verticalPosition || 'bottom',
            horizontalPosition: options?.horizontalPosition || 'center'
        };
    }
}
